export default __webpack_public_path__ + "assets/586666c540174ea49c4069dd7399221b.jpg";